<form [formGroup]="formCtrl()" (ngSubmit)="authorize()">
  <ng-template #oAuth2FormFieldTpl let-label="label" let-name="name" let-required="required">
    @let fieldId = `${formId}-${name}`;
    <div class="form-group mr-32 mt-16">
      <div class="form-control side-label column-limited">
        <label [for]="fieldId" class="bd-field-label" [class.required]="required">{{
          label
        }}</label>
      </div>
      <div class="form-control ml-8 grow">
        <input
          [formControlName]="name"
          [id]="fieldId"
          [required]="required"
          autocomplete="off"
          class="bd-text-input tall"
        />
      </div>
    </div>
  </ng-template>

  <div class="form-group mr-32 mt-16">
    @let fieldId = `${formId}-credentialType`;
    <div class="form-control side-label column-limited">
      <label [for]="fieldId" class="bd-field-label required">
        Send client credentials
        <mat-icon
          blazeTooltip="Some identity providers require sending Client ID and Secret in the request body instead of headers. Choose the appropriate option based on your provider’s documentation."
          class="tooltip-hint"
          svgIcon="icon_question_16"
        />
      </label>
    </div>
    <div class="form-control ml-8 grow text-primary-darker">
      <mat-button-toggle-group
        [id]="fieldId"
        class="button-group-input stretch"
        formControlName="oAuth2CredentialType"
      >
        <mat-button-toggle [value]="CredentialType.AuthorizationHeader">
          In Request Header
        </mat-button-toggle>
        <mat-button-toggle [value]="CredentialType.PostBody">In Request Body</mat-button-toggle>
      </mat-button-toggle-group>
      @if (credentialType()) {
        <div class="form-control-description">
          @switch (credentialType()) {
            @case (CredentialType.AuthorizationHeader) {
              Credentials sent using Basic Auth.
            }
            @case (CredentialType.PostBody) {
              Credentials included in the token request body
            }
          }
        </div>
      }
    </div>
  </div>

  @if (!useClientCredentials()) {
    <ng-container
      *ngTemplateOutlet="
        oAuth2FormFieldTpl;
        context: { label: 'Auth URL', name: 'authorizeUrl', required: true }
      "
    />
  }
  <ng-container
    *ngTemplateOutlet="
      oAuth2FormFieldTpl;
      context: { label: 'Access Token URL', name: 'tokenUrl', required: true }
    "
  />
  <ng-container
    *ngTemplateOutlet="
      oAuth2FormFieldTpl;
      context: { label: 'Client ID', name: 'clientId', required: true }
    "
  />
  <ng-container
    *ngTemplateOutlet="
      oAuth2FormFieldTpl;
      context: { label: 'Client Secret', name: 'clientSecret', required: true }
    "
  />
  <ng-container
    *ngTemplateOutlet="
      oAuth2FormFieldTpl;
      context: { label: 'Scope (Optional)', name: 'scope', required: false }
    "
  />

  <div class="form-group mr-32 mt-16" [class.invisible]="useClientCredentials()">
    <div class="form-control side-label column-limited"></div>
    <div class="form-control ml-8 grow">
      <div class="btn-container">
        <button type="submit" blazeButton class="uppercase" [disabled]="formCtrl().invalid">
          Authorize
        </button>
      </div>
    </div>
  </div>
</form>
